import { Features, useGetVariant } from '@finn/ua-featureflags';
import { useIntl } from '@finn/ui-utils';

import { useDiscoveryConfig } from '../../core/data/MetadataProvider';
import { GenericVehicleDetails } from '../../core/types';
import { PriceInformation } from '../../price/PriceInformation';
import { PartialCartInfo, useSubscriptionPrice } from '../../product-pricing';

export const SubscriptionPrice = ({
  className,
  closedUserGroupId,
  cartInfo,
  vehicle,
}: {
  className?: string;
  closedUserGroupId?: string;
  cartInfo?: PartialCartInfo;
  vehicle?: GenericVehicleDetails;
}) => {
  const i18n = useIntl();

  const {
    originalPriceFormatted,
    finalPriceFormatted,
    isDownPayment,
    isForBusiness,
  } = useSubscriptionPrice({
    trackPartnerDiscount: true,
    closedUserGroupId,
    cartInfo,
    vehicle,
  });

  const { forceRegularPrice } = useDiscoveryConfig();
  const isDownpaymentLabelExp =
    useGetVariant(Features.ExpServiceFeeDesign) !== 'a';

  const title = i18n.formatMessage(
    `pdp.price.${isForBusiness || forceRegularPrice ? 'b2b' : 'b2c'}_vat`
  );

  return (
    <div className={className}>
      <div className="flex">
        <span className="inline-block mobile-t3-semibold sm:web-t3-semibold">
          {i18n.formatMessage('pdp.price.starting_from')}&nbsp;
        </span>

        {originalPriceFormatted && (
          <span className="mr-2 inline-block !text-iron line-through mobile-t3-semibold sm:web-t3-semibold">
            {originalPriceFormatted}
          </span>
        )}

        <span className="inline-block mobile-t3-semibold sm:web-t3-semibold">
          {finalPriceFormatted}
        </span>

        <PriceInformation className="font-normal" />
      </div>
      <div className="flex-row pt-4 body-14-light">
        <span>
          {title}{' '}
          {isDownPayment &&
            (isDownpaymentLabelExp
              ? 'zzgl. einer Servicepauschale'
              : i18n.formatMessage('pdp.downPayment.priceText'))}
        </span>
      </div>
    </div>
  );
};
